/*
 * @Author: mikey.zhaopeng 
 * @Date: 2018-10-30 11:07:06 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2018-10-30 11:07:41
 */


export const GET_CURRENT_TIME = 'store_getCurrentTime'; 


// WEBPACK FOOTER //
// ./src/components/common/utils/store/interfaces.js